/**
 * @generated SignedSource<<856aa45e6465704d4c963d902058d3a1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type fallback_nativeIssueTable_FallbackCell$data = {
  readonly hoverOrFocusState?: {
    readonly " $fragmentSpreads": FragmentRefs<"popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent">;
  } | null | undefined;
  readonly id?: string;
  readonly renderedFieldHtml: string | null | undefined;
  readonly type: string;
  readonly " $fragmentType": "fallback_nativeIssueTable_FallbackCell";
};
export type fallback_nativeIssueTable_FallbackCell$key = {
  readonly " $data"?: fallback_nativeIssueTable_FallbackCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"fallback_nativeIssueTable_FallbackCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "fallback_nativeIssueTable_FallbackCell",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "concreteType": "JiraFieldHoverOrFocusState",
              "kind": "LinkedField",
              "name": "hoverOrFocusState",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "renderedFieldHtml"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    }
  ],
  "type": "JiraFallbackField"
};

(node as any).hash = "106fe6ac93c70d998cbd58deff11a3ee";

export default node;
